namespace Ir.Components.General.Intro {

    interface IViewModel {
        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popover: DevExpress.ui.dxPopover;
        checkBoxConfig: DevExpress.ui.dxCheckBox.Properties;
        introText: KnockoutObservable<string>;
        intro: Intro;
        step: number;
        toolbarItems: Array<DevExpress.ui.dxPopup.ToolbarItem>;
        overlay: HTMLDivElement;
        showDontShowAgain: KnockoutObservable<boolean>;
    }
    export interface IParams {
        //intro: Intro;
        callback(component: IIntroPopover);
    }

    export interface IIntroPopover {
        show(intro: Intro);
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;

        self.introText = ko.observable("");

        self.overlay = document.createElement('div');
        self.overlay.className = 'intro-overlay';
        document.body.appendChild(self.overlay);

        self.toolbarItems = [
            {
                locateInMenu: 'always',
                widget: 'dxButton',
                toolbar: 'top',
                visible: false,
                options: {
                    text: 'More info',
                    onClick() {
                        DevExpress.ui.notify({
                            message: "info message",
                            position: {
                                my: 'center top',
                                at: 'center top',
                            },
                        }, 'success', 3000);
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'before',
                visible: false,
                options: {
                    text: 'Back',
                    icon: 'chevronprev',
                    stylingMode: 'outlined',
                    type: 'normal',
                    elementAttr: {
                        class: "intro-step-button",
                    },
                    onClick() {
                        updateStep(self, "back");
                    },
                },
            },
            {
                widget: 'dxTextBox',
                toolbar: 'bottom',
                location: 'center',
                visible: false,
                options: {
                    value: "",
                    readOnly: true,
                    width: 50,
                    labelMode: "static",
                    label: "Step",
                    elementAttr: {
                        class: "intro-step-info",
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                visible: true,
                options: {
                    icon: 'chevronnext',
                    stylingMode: 'contained',
                    text: 'Next',
                    elementAttr: {
                        class: "intro-step-button",
                    },
                    onClick() {
                        updateStep(self, "next");
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                visible: false,
                options: {
                    icon: 'check',
                    stylingMode: 'contained',
                    text: 'Done',
                    elementAttr: {
                        class: "intro-step-button",
                    },
                    onClick() {
                        self.popover.hide();
                    },
                },
            }
        ];

        this.showDontShowAgain = ko.observable(false);

        self.popoverConfig = {
            position:  "bottom",
            width: 300,
            showTitle: true,
            title: "Create new Report",
            showCloseButton: true,
            wrapperAttr: {
                class: "intro-popover",
            },
            onInitialized: function (e) {
                self.popover = e.component;
                if (params.callback) {
                    params.callback({
                        show(intro: Intro) {
                            self.step = 0;
                            self.intro = intro;
                            self.showDontShowAgain(intro.showDontShowAgain);
                            updateStep(self);
                        },
                    } as IIntroPopover);
                }
            },
            onShowing(e) {
                $(self.overlay).css("display", "");
            },
            onHiding(e) {
                $(self.overlay).css("display", "none");
                self.intro.save();
            },
        };

        self.checkBoxConfig = {
            value: false,
            text: "Don't show this again",
            elementAttr: {
                
            },
            onValueChanged(data) {
                self.intro.dontShowAgain = data.value;
            },
        };
    }

    function updateStep(vm: IViewModel, direction?: string) {
        let previousStep = direction !== null ? vm.intro.steps[vm.step] : null;
        if (previousStep?.after) {
            previousStep.after();
        }

        if (direction === "next" && vm.step < vm.intro.steps.length - 1) {
            vm.step++;
        }
        if (direction === "back" && vm.step > 0) {
            vm.step--;
        }

        let currentStep = vm.intro.steps[vm.step];

        if (currentStep.before) {
            if (!currentStep.before(() => {
                executeStep(vm, currentStep);
            })) {
                executeStep(vm, currentStep);
            }
        }
        else {
            executeStep(vm, currentStep);
        }
        
    }

    function executeStep(vm: IViewModel, currentStep: IntroStep) {
        let element = $(currentStep.element)[0]; //document.querySelector(currentStep.element);

        vm.popover.option("title", currentStep.title);
        vm.popover.option("position", currentStep.position ?? "bottom");
        vm.popover.option("target", element);
        vm.introText(currentStep.text);
        let rect = element.getBoundingClientRect();
        let padding = 2;
        let width = rect.width;
        let height = rect.height;
        let left = rect.left;
        let top = rect.top;

        if (currentStep.extraElement) {
            let extraElement = $(currentStep.extraElement)[0]; //document.querySelector(currentStep.extraElement);
            if (extraElement) {
                let extraRect = extraElement.getBoundingClientRect();
                if (extraRect.left < left) {
                    left = extraRect.left;
                }
                if (extraRect.top < top) {
                    top = extraRect.top;
                }
                height = (extraRect.bottom > rect.bottom ? extraRect.bottom : rect.bottom) - top;
                width = (extraRect.right > rect.right ? extraRect.right : rect.right) - left;
            }
            else {
                console.warn(`Intro: extra element not found ${currentStep.extraElement} for step ${currentStep.title}`);
            }
        }

        $(vm.overlay).css("width", width + padding * 2);
        $(vm.overlay).css("height", height + padding * 2);
        $(vm.overlay).css("top", top - padding);
        $(vm.overlay).css("left", left - padding);

        //back
        vm.toolbarItems[1].visible = vm.step > 0;
        //step info
        vm.toolbarItems[2].options.text = `${vm.step + 1} of ${vm.intro.steps.length}`;
        //next
        vm.toolbarItems[3].visible = vm.step < vm.intro.steps.length - 1;
        //done
        vm.toolbarItems[4].visible = vm.step == vm.intro.steps.length - 1;

        vm.popover.option("toolbarItems", vm.toolbarItems);
        vm.popover.option("width", currentStep.width ?? 300);
        vm.popover.show();
    }
}